import { pickDefaultCustomerAddress } from '#/modules/crmMgmt/customer/helper/customerAddress';

function formatCustomerAddressLine(row) {
  if (!row) {
    return '';
  }
  return [row.postalCode, row.address].filter(Boolean).join(' ');
}

function pickSignReceiptSnapshotAddress(addresses = []) {
  return pickDefaultCustomerAddress(addresses, 'BILLING')
    ?? pickDefaultCustomerAddress(addresses, 'SHIPPING')
    ?? (addresses ?? []).find((row) => row?.isDefault)
    ?? (addresses ?? [])[0]
    ?? null;
}

function pickContactById(contacts = [], contactId) {
  if (!contactId) {
    return null;
  }
  return (contacts ?? []).find((row) => row?.id === contactId) ?? null;
}

export const EMPTY_SIGN_RECEIPT_CUSTOMER_SNAPSHOT = {
  customerName: '',
  contactName: '',
  phone: '',
  fax: '',
  taxId: '',
  address: '',
};

/**
 * Customer detail → 簽收單客戶快照欄（可編輯 FloatingInput）。
 * 須帶入 `contactId` 才填 contactName；其餘欄來自客戶主檔／預設地址。
 * 無 FK：僅映射快照字串。
 *
 * @param {object | null | undefined} customerDetail
 * @param {string | null | undefined} contactId
 */
export function mapCustomerDetailToSignReceiptSnapshot(customerDetail, contactId) {
  if (!customerDetail) {
    return { ...EMPTY_SIGN_RECEIPT_CUSTOMER_SNAPSHOT };
  }

  const contact = pickContactById(customerDetail.contacts, contactId);
  const address = pickSignReceiptSnapshotAddress(customerDetail.addresses);

  return {
    customerName: customerDetail.name ?? '',
    contactName: contact?.name ?? '',
    phone: customerDetail.phone ?? '',
    fax: customerDetail.fax ?? '',
    taxId: customerDetail.taxIdNumber ?? '',
    address: formatCustomerAddressLine(address),
  };
}
